import type { Resort } from '@/shared/model';
import type { Selection } from '../model/types';

export function getDestinationResortIds(destination: Selection | null): number[] {
  return destination?.kind === 'resorts' ? destination.resorts.map((resort) => resort.id) : [];
}

export function getDestinationCountryResorts(destination: Selection | null): Resort[] {
  if (!destination || destination.kind === 'none') return [];

  const catalog = destination.country.resorts ?? [];
  const catalogIds = new Set(catalog.map((resort) => resort.id));
  const selectedOutsideCatalog =
    destination.kind === 'resorts' ? destination.resorts.filter((resort) => !catalogIds.has(resort.id)) : [];

  return [...catalog, ...selectedOutsideCatalog];
}

function hasSameIds(first: readonly number[], second: readonly number[]): boolean {
  const firstIds = new Set(first);
  const secondIds = new Set(second);

  return firstIds.size === secondIds.size && [...firstIds].every((id) => secondIds.has(id));
}

export function withDestinationResorts(destination: Selection | null, resortIds: readonly number[]): Selection | null {
  if (!destination || destination.kind === 'none') return destination;

  if (hasSameIds(getDestinationResortIds(destination), resortIds)) return destination;

  const selectedIds = new Set(resortIds);
  const resorts = getDestinationCountryResorts(destination).filter((resort) => selectedIds.has(resort.id));

  if (resorts.length === 0) return { kind: 'country', country: destination.country };

  return { kind: 'resorts', country: destination.country, resorts };
}
